export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "formulabih-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "formulabih-themeWrapLive" */'./LiveThemeImporter'),
  },
};
